import { render, staticRenderFns } from "./MenuToday.vue?vue&type=template&id=093e7d32&"
import script from "./MenuToday.vue?vue&type=script&lang=js&"
export * from "./MenuToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports